<section class="container-fluid sts-section sts-form" tabindex="0">

  <app-sts-section-header key="sts-signup-header" [errors]="errors">
    Provide key identifiers
    <app-sts-section-header-side>
      <div class="text-right"><a
        routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <app-sts-section-body key="sts-registration-body-section">
    Please provide the following information to continue the self-registration process.
    Select <b>Next</b> when you are finished.
  </app-sts-section-body>


  <app-sts-self-identifiers [mode]="mode"
                            (onCancel)="gotoHome($event)"
                            (onErrors)="showErrors($event)"
                            (onSuccess)="onSuccess($event)"></app-sts-self-identifiers>


</section>


